<template>
    <v-card elevation="2" shaped class="ma-1">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Parametres d'Envoi de SMS</v-toolbar-title>
      </v-toolbar>

      <div>
        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> Corp du SMS </v-tab>
          <v-tab> Requete pour SMS et crochets </v-tab>
          <v-tab> Numeros de telephone </v-tab>
          <v-tab> Envoi groupe </v-tab>
          <v-tabs-items v-model="tab" class="pl-4">

            <v-tab-item>
              <v-row>
                <v-col class="ma-1">
                    Definissez le corp et le titre du SMS. Soit a partir de champs d'une table, soit directement dans le module
                    <Select
                    :item="{name: 'Quel corp de SMS allez-vous choisir ?',value: 'type',liste: [{ text: 'selectionner', value: '' },{ text: 'Construire mon SMS dans ce module', value: 'manual' },{ text: 'Choisir a partir d\'un element d\'une table', value: 'fromfield' }],
                    defaultprops:{ show: true, column: false }}"
                    :change="cc"
                    :valField="displays.params.type"
                    />


                    <div v-if="displays.params.type == 'manual'">

                <TextField
                :item="{ name: 'Titre du SMS', value: 'titre' ,defaultprops:{ show: true }}"
                :valField="displays.params.manual.titre"
                :keyup="(item,model)=> { displays.params.manual.titre = model; $emit('recepVal',displays); }"
                />
                <TextArea
                :item="{ name: 'Corp du SMS', value: 'corp' ,defaultprops:{ show: true, autogrow: true, row: 5 }}"
                :valField="displays.params.manual.corp"
                :keyup="(item,model)=> { displays.params.manual.corp = model; $emit('recepVal',displays); }"
                />
                    </div>

                    <div v-if="displays.params.type == 'fromfield'">
                        <Autocomplete
                            :item="{ 
                                name: 'Selectionnez la table sujete au corp du SMS', 
                                value: 'table', 'liste': itemTableListe,
                                defaultprops:{ show: true, chips: false, deletablechips: false, modelRules: [v => !!v || 'Ce champ doit etre renseigne'] }
                            }" :valField="displays.params.fromfield.table" :change="(item,value,select) => { displays.params.fromfield.table = value[select]; $emit('recepVal',displays) }" />  


                        <v-tabs align="start" :key="displays.params.fromfield.table" background-color="blue lighten-5" v-model="tab2" v-if="displays.params.fromfield.table">
                        <v-tab> Filtres </v-tab>
                        <v-tab> Champs </v-tab>
                        <v-tabs-items v-model="tab2" class="pl-4">
                            <v-tab-item>

                                <Filtre                              
                                :filtre="displays.params.fromfield.filter"
                                :table="displays.params.fromfield.table"
                                @recepVal="(data) => {displays.params.fromfield.filter = data; $emit('recepVal',displays)}"
                                />
                            </v-tab-item>

                            <v-tab-item>
                                <p>Vous devez choisir le corp et le titre du SMS en nommant les valeurs du as en "corp" et "titre"</p>
                                <Fields
                                :table="displays.params.fromfield.table"
                                :champs="displays.params.fromfield.champs"
                                :filter="displays.params.fromfield.filter"
                                :modalKey="modalKey"
                                :page="page"
                                @recepVal="(data) => {displays.params.fromfield.champs = data; $emit('recepVal',displays)}"
                                />
                            </v-tab-item>
                        </v-tabs-items>
                        </v-tabs>

                    </div>


                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>

              <v-tabs align="start" background-color="blue lighten-5" class="ma-3" v-model="tabAff">
                        <v-tab> Filtres </v-tab>
                        <v-tab> Champs </v-tab>
                        <v-tabs-items v-model="tabAff" class="pl-4">
                            <v-tab-item>
                              Le filtre va permettre de construire la requete pour affilier les crochets situes dans le corp du SMS afin de les remplacer par les valeurs de la requete
                                <Filtre
                                  :filtre="displays.filter"
                                  :table="module.table"
                                  @recepVal="changeFilter"
                                />
                            </v-tab-item>

                            <v-tab-item>
                              <p class="font-weight-medium">Veuillez nommer le AS des champs au nom des crochets pour affiliation. ex : {_nom_} = nom</p>

                              <v-btn @click="recupHooks">Recuperer les crochets pour affiliation</v-btn>

                              <div v-for="(list,i) in listHooks" :key="i" :class="['font-weight-bold',list.valid ? 'green--text':'red--text']"><span v-if="!list.valid">Affilier le crochet</span> {{ list.hook }} <span></span></div>

                              <Fields
                              :table="module.table"
                              :modalKey="modalKey"
                              :champs="displays.params.champs"
                              :filter="displays.filter"
                              :page="page"
                              @recepVal="(data) => {displays.params.champs = data; $emit('recepVal',displays); verifySync()}"
                              />
                            </v-tab-item>
                        </v-tabs-items>
                        </v-tabs>

            </v-tab-item>
          <v-tab-item>
            <p class="font-weight-medium">Vous pouvez integrer une variable de requete par [[line||mon_AS]]</p>

            <TextField
            :item="{ name: 'Code pays par defaut', value: 'countrycode' ,defaultprops:{ show: true, description:'Ex: +33 ou 0033' }}"
            :valField="displays.params.countrycode"
            :keyup="(item,model)=> { displays.params.countrycode = model; $emit('recepVal',displays); }"
            />
            <TextField
            :item="{ name: 'Nom de l\'expediteur', value: 'sender' ,defaultprops:{ show: true }}"
            :valField="displays.params.sender"
            :keyup="(item,model)=> { displays.params.sender = model; $emit('recepVal',displays); }"
            />
            <ArrayTable 
                :item="{otherparams:{
                    arrayTable:[
                        {type:'',key:'numero',name:'numero de telephone'},                           
                        {type:'',key:'alias',name:'alias'}]}
                ,defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'ajouter un numero'}}"
                :valField="displays.params.phones"
                :change="(item,value) => {displays.params.phones = value; $emit('recepVal',displays);}"
                />
          </v-tab-item>


          <v-tab-item>
            <!-- envoi groupe-->
            <SwitchC
            :item="{ name: 'Activer l\'envoi groupe', value: 'right', defaultprops:{ show: true }}"
            :valField="displays.params.group.set"
            :change="(item,value) => {displays.params.group.set = value; $emit('recepVal',displays);}"
            />

            <div v-if="displays.params.group.set">
              <p>Construisez la requete permettant la liste de diffusion</p>
              <p>ATTENTION : en fonction du parametrage du module et de la selection du corp, les sms peuvent etre differents dans leurs contenus</p>
              <v-tabs align="start" background-color="blue lighten-5" class="ma-3" v-model="tab3">
                        <v-tab> Filtres </v-tab>
                        <v-tab> Champs </v-tab>
                        <v-tabs-items v-model="tab3" class="pl-4">
                            <v-tab-item>
                              <p class="font-weight-medium">Vous pouvez utiliser la variable 'line' issue de la requete pour l'envoi groupe : [[line||mon_as]]</p>
                                <Filtre
                                  :filtre="displays.params.group.query.filter"
                                  :table="module.table"
                                  @recepVal="(array) => {displays.params.group.query.filter = array; $emit('recepVal',displays)}"
                                />
                            </v-tab-item>

                            <v-tab-item>
                              <p class="font-weight-medium">Chaque AS correspondra a un nom de colonne du tableau.Il y aura une jonction automatique avec la table smssents</p>
                              <Fields
                              :table="module.table"
                              :modalKey="modalKey"
                              :champs="displays.params.group.query.champs"
                              :filter="displays.params.group.query.filter"
                              :page="page"
                              @recepVal="(data) => {displays.params.group.query.champs = data; $emit('recepVal',displays);}"
                              />
                            </v-tab-item>
                        </v-tabs-items>
                        </v-tabs>

            </div>


            </v-tab-item>

          </v-tabs-items>
        </v-tabs>
    </div>
    </v-card>
  </template>



  <script>
    import { admin } from '../mixins';
  export default {
    name: "SendSms",

    mixins : [admin],

    components: {
      TextArea: () => import('@/components/fields/textarea.vue'),
    },


    data: function () {
      return {

        displays: this.module.displays,
        tab : null,
        tab2 : null,
        tab3 : null,
        tabAff : null,
        listHooks : [],

      };
    },

    watch: {

  },

    methods: {

        cc(item,value,selectedKey) {
            this.displays.params[item.value] = value[selectedKey]
            this.$emit('recepVal',this.displays)
        },

        recupHooks() {
          this.listHooks = []
          if(this.displays.params.type=='fromfield') {
            let isCorp = this.displays.params.fromfield.champs.find((el) => el.as =='corp')
            if(!this.displays.params.fromfield.table || !isCorp) {
                this.$toast.warning('Veuillez selectionner la table et le corp dans l\'onglet corp de SMS');
                return
            }

            this.getListField({filter:{table:this.displays.params.fromfield.table}}).then((resp) => {
                var getVars = []

                            resp.forEach((field) => {
                                if(field.table+"."+field.field == isCorp.field) {
                                  // on update l'id du champ qui fait l'objet du corp, ca permettra de sortir ce champ si l'user veut modifier avant d'envoyer
                                  this.displays.params.fromfield.idField = field.id
                                  this.$emit('recepVal',this.displays)
                                    getVars = field.displays.otherparams.menueditor
                                    if(getVars) {
                                      getVars.forEach((groupList) => {
                                          groupList.list.forEach((elem) => {
                                              if(elem.value!==null && elem.value!='') this.listHooks.push({hook:elem.value,valid:false})
                                          })
                                      })
                                    }
                                }
                            })
                            this.verifySync();
                        })
          }

          if(this.displays.params.type=='manual') {
            const resultats = this.displays.params.manual.corp.match(/\{_(.*?)_\}/g);
            if(Array.isArray(resultats)) resultats.forEach((elem) => { this.listHooks.push({hook:elem,valid:false}) })
          }

        },

        verifySync() {
            this.listHooks.forEach((hook,h)=> {
                this.listHooks[h].valid = false;
                let name = hook.hook.match(/{_([^}]+)_}/)[1];
                if(this.displays.params.champs.find((el) =>  el.as == name)) this.listHooks[h].valid = true;
            })
        },

      changeFilter(array) {
      this.displays.filter = array
      this.$emit('recepVal',this.displays)
    },

    },

    mounted() {

    },
  };
  </script>


